import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class PtReservationMaskService {
  private api = inject(ApiService);

  get(id: number) { return this.api.get(`/reservation/schedule/${id}`); }
  getAll(studioId: number) { return this.api.get(`/reservation/schedule/studio/${studioId}`); }
  create(json: any) { return this.api.post('/reservation/schedule', json); }
  remove(json: any) { return this.api.post('/reservation/mask/remove', json); }
}
